import { Component, Signal, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../../service/layout.service';
import { Router } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { User } from "@supabase/supabase-js";
import { ButtonModule } from "primeng/button";
import { AuthService } from "@services/auth";

@Component({
  selector: 'app-topbar-menu',
  standalone: true,
  imports: [CommonModule, StyleClassModule, ButtonModule],
  templateUrl: './app-topbar-menu.html',
})
export class AppTopbarMenu {
    user: Signal<User | null>;

    constructor(
        public layoutService: LayoutService,
        private authService: AuthService,
        private router: Router
    ) {
        this.user = toSignal(this.authService.user$, { initialValue: null });
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }

    logout() {
        this.authService.signOut().subscribe({
            next: () => {
                this.router.navigate(['/auth/login']);
            },
            error: (error: any) => {
                console.error('Logout failed:', error);
            }
        });
    }
}
